// Function to create gradient colors from light gray to black with last item as green
export const createGradientColors = (dataArray, opacity = 0.7) => {
  const totalItems = dataArray.length;

  // Return empty array if no data
  if (totalItems === 0) return [];

  // Special case: if only one item, return green
  if (totalItems === 1) {
    return [`rgba(0, 176, 80, ${opacity})`]; // #00b050 with opacity
  }

  return dataArray.map((_, index) => {
    // If it's the last item, return green
    if (index === totalItems - 1) {
      return `rgba(0, 176, 80, ${opacity})`; // #00b050 with opacity
    }

    // Otherwise create a gradient from light gray to black
    // Light gray (rgb(211,211,211)) to black (rgb(0,0,0))
    const grayValue = Math.round(211 - (211 * index) / (totalItems - 2));
    return `rgba(${grayValue}, ${grayValue}, ${grayValue}, ${opacity})`;
  });
};

// Function to color the highest value green and create a gradient for the rest
export const createHighestValueColors = (dataArray, opacity = 0.7) => {
  // Return empty array if no data
  if (dataArray.length === 0) return [];

  // Special case: if only one item, return green
  if (dataArray.length === 1) {
    return [`rgba(0, 176, 80, ${opacity})`]; // #00b050 with opacity
  }

  // Find highest value and its index
  const highestValue = Math.max(...dataArray);
  const highestIndex = dataArray.indexOf(highestValue);

  // Sort data for gradient calculation (without modifying original array)
  const sortedData = [...dataArray].sort((a, b) => a - b);

  // Create new array with colors
  return dataArray.map((value, index) => {
    // If it's the highest value, return green
    if (index === highestIndex) {
      return `rgba(0, 176, 80, ${opacity})`; // #00b050 with opacity
    }

    // Find position in sorted array for gradient calculation
    const position = sortedData.indexOf(value);

    // Calculate gradient from light gray to black based on sorted position
    const gradientPosition = position / (dataArray.length - 2);
    const grayValue = Math.round(211 - 211 * gradientPosition);

    return `rgba(${grayValue}, ${grayValue}, ${grayValue}, ${opacity})`;
  });
};
